import register from '../util/register'
import angular from 'angular'
import AccountManagementController from './AccountManagementController'
import AccountSettingsController from './AccountSettingsController'
import PaymentManagementController from './PaymentManagementController'
import AccountService from './AccountService'
import AlertCountService from '../alerts-management/AlertCountService'
import SubscriptionController from './SubscriptionController'
import UpdateSubscriptionModalController from './UpdateSubscriptionModalController'
import '../auth/auth.module'
import '../billing/billing.module'
import '../password-reset/password-reset.module'

var accountManagement = angular.module(
  'app.accountManagement',
  [
    'app.alertsManagement',
    'app.auth',
    'app.billing',
    'app.passwordReset'
  ])

register('app.accountManagement')
  .service('AccountService', AccountService)
  .service('AlertCountService', AlertCountService)
  .controller('AccountManagementController', AccountManagementController)
  .controller('AccountSettingsController', AccountSettingsController)
  .controller('PaymentManagementController', PaymentManagementController)
  .controller('SubscriptionController', SubscriptionController)
  .controller('UpdateSubscriptionModalController', UpdateSubscriptionModalController)

accountManagement.run()
